<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title id="onco-net-title">ONCO-NET</ion-title>

    <ion-button ion-button slot="start" (click)="back()" *ngIf="canGoBack()" aria-label="Back Button">
      <ion-icon slot="icon-only" name="arrow-back-outline" />
    </ion-button>

    <ion-button ion-button slot="end" (click)="accountModal.open()" aria-label="Account Button">
      <ng-container *ngIf="!account.session?.picture">
        <ion-icon class="profile-picture" slot="icon-only" name="person-circle-outline" aria-label="Account Icon" />
      </ng-container>
      <ng-container *ngIf="account.session?.picture">
        <img class="profile-picture" slot="icon-only" alt="Information icon representing the user account"
          [src]="account.session?.picture" />
      </ng-container>
    </ion-button>
  </ion-toolbar>
</ion-header>

<app-account-modal #accountModal />